module.exports = __webpack_public_path__ + "static/media/Group5.31f29784.png";